module.exports = __webpack_public_path__ + "img/apple.675f479a.png";